import React from "react";
import { Box, Stack, useTheme } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import NotesIcon from "@mui/icons-material/Notes";
import moment from "moment";

import Typography from "components/basic/typography";

import { Booking } from "../../../../types";

const Row: React.FC<{ icon: React.ReactNode; children: React.ReactNode }> = ({
  icon,
  children,
}) => (
  <Stack direction="row" spacing={1.5} alignItems="flex-start">
    <Box sx={{ color: "text.secondary", mt: "2px" }}>{icon}</Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
  </Stack>
);

const DetailsSection: React.FC<{ booking: Booking }> = ({ booking }) => {
  const theme = useTheme();
  const timeText = booking.allDay
    ? "All day"
    : `${moment(booking.from, "HH:mm").format("h:mm A")} – ${moment(
        booking.to,
        "HH:mm",
      ).format("h:mm A")}`;

  return (
    <Stack spacing={1.5}>
      <Row icon={<AccessTimeIcon fontSize="small" />}>
        <Typography variant="body2" style={{ fontWeight: 500 }}>
          {moment(booking.date).format("ddd, MMM D, YYYY")}
        </Typography>
        <Typography
          variant="caption"
          style={{ color: theme.palette.text.secondary }}
        >
          {timeText}
        </Typography>
      </Row>

      {booking.location && (
        <Row icon={<PlaceOutlinedIcon fontSize="small" />}>
          <Typography variant="body2">{booking.location}</Typography>
        </Row>
      )}

      {booking.description && (
        <Row icon={<NotesIcon fontSize="small" />}>
          <Typography variant="body2">{booking.description}</Typography>
        </Row>
      )}
    </Stack>
  );
};

export default DetailsSection;
